<script>
  import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Styles,
    Icon,
  } from "sveltestrap";

  import { _ } from "../i18n.js";

  export let menuItems;
  export let headerText = undefined;
  export let current;
  export let selectChart;
  export let autoScroll = true;
</script>

<!-- <Styles /> -->


<Dropdown class="mt-2 ms-2">
  <DropdownToggle color="primary" caret><Icon name="list" /></DropdownToggle>
  
  <DropdownMenu >
    <div class:scrollable={autoScroll} >
    {#if headerText}
      <DropdownItem header>{$_(headerText)}</DropdownItem>
    {/if}
    {#each menuItems as item}
      <DropdownItem
        on:click={selectChart}
        id={item}
        
        active={current === item}>{$_(item)}</DropdownItem
      >
    {/each}
    </div>
  </DropdownMenu>
  
  
</Dropdown>


<style>
    .scrollable {
        height: auto;
        max-height: 400px;
        overflow-x: hidden;
    }
</style>